export var Utility = {
  GetCurrent: function () {

    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch (e) {
      return null;
    }

  },
  SetCurrent: function (datas) {
    localStorage.setItem("user", JSON.stringify(datas));
  },
  SetToken: function (token) {
    localStorage.setItem("user-token", token);
  },
  GetToken: function () {
    try {
      return localStorage.getItem("user-token");
    } catch (e) {
      return null;
    }

  },
  Shuffle: function (array) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }
}
